var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deng fadeInDown animated",style:('background:url(' +
    _vm.dengBgImg[_vm.dengIndex] +
    ') center top / cover no-repeat')},[_c('img',{staticClass:"img-btn fadeInDown animated",attrs:{"src":_vm.dengImg[_vm.charIndex]}}),_c('img',{staticClass:"deng-char",attrs:{"src":require("../assets/images/deng/char.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }